import { parse, toSeconds } from 'iso8601-duration';

export function isoDurationToSeconds(duration: string): number {
  try {
    const parsedDuration = parse(duration);
    const seconds = toSeconds(parsedDuration);

    if (typeof seconds !== 'number' || isNaN(seconds)) {
      throw new Error();
    }

    return seconds;
  } catch {
    throw new Error(`Invalid ISO duration: ${JSON.stringify(duration)}`);
  }
}

export function isoDurationToMilliseconds(duration: string): number {
  const seconds = isoDurationToSeconds(duration);
  return seconds * 1000;
}
